module.exports = __webpack_public_path__ + "img/165.be98155c.jpg";